import React from 'react'
import { ContentListSimple } from 'Blocks'

const ArticlesLoading = () => <ContentListSimple isLoading />

export default ArticlesLoading
